import styled, { css, DefaultTheme } from 'styled-components';
import { Wrapper as FormButton } from 'components/Button/style';
import { Row as GridRow, Col } from 'components/GridSystem';

type WrapperProps = {
  minimal?: boolean;
};

const wrapperModifiers = {
  default: (theme: DefaultTheme) => css`
    background-color: ${theme.colors.globalWhite100};
    border-top: 1px solid ${theme.colors.neutral300};
    border-radius: 8px 8px 0 0;
    padding: 28px 0;
  `,
};

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, minimal }) => css`
    width: 100%;
    display: flex;
    justify-content: center;
    ${!minimal && wrapperModifiers.default(theme)}

    ${FormButton} {
      margin-bottom: 8px;

      &:disabled {
        background-color: ${theme.colors.neutralDark30};
        cursor: not-allowed;
      }

      @media (max-width: 576px) {
        margin-bottom: 0;
      }
    }
  `}
`;

export const Row = styled(GridRow)`
  justify-content: space-between;
`;

export const ShowMobile = styled.div`
  @media (max-width: 576px) {
    display: flex;
    height: 100%;
  }

  @media (min-width: 577px) {
    display: none;
  }
`;

export const ShowDesktop = styled.div`
  @media (max-width: 576px) {
    display: none;
  }
  @media (min-width: 577px) {
    display: block;
  }
`;

export const VehicleCol = styled(Col)`
  display: flex;
  align-items: center;
`;

export const Details = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Code = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark60};
    font-size: 1.2rem;

    @media (max-width: 576px) {
      margin-bottom: 8px;
    }
  `}
`;

export const Label = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.statusSuccess40};
    font-weight: 700;
  `}
`;

export const Stripe = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark60};
    font-size: 1.2rem;
    display: flex;
    align-items: center;

    > svg {
      color: ${theme.colors.neutralDark100};
      margin-right: 8px;
    }

    > img {
      margin-left: 4px;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 8px;
`;
